import { useContext } from "react";

import Spinner from "react-bootstrap/Spinner";

import { AppContext } from "/src/components/context/App";

const SPINNER_SIZE = 100;

const style = {
	busyIndicatorContainer: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.8)',
		zIndex: 9999
	},
	busyIndicator: {
		padding: "8px",
	},
	busyIndicatorText: {
		padding: "8px",
		alignItems: 'center',
		backgroundColor: 'rgba(0,0,0,0)',
		color: "#fff",
	}
};

const getStyle = (context) => {
	// { ...style.busyIndicatorContainer, position }
	const { fullscreen, spinner } = context;
	if (fullscreen) {
		return {
			spinnerVariant: "light",
			spinnerContainerStyle: {
				...style.busyIndicatorContainer,
				position: "fixed",
			}
		}
	}
	else {
		switch (spinner) {
			case "block":
				return {
					spinnerVariant: "dark",
					spinnerContainerStyle: {
						position: "block"
					}
				}
			case "absolute":
			default:
				return {
					spinnerVariant: "light",
					spinnerContainerStyle: {
						...style.busyIndicatorContainer
					}
				}
		}
	}
}

const Component = ({ isLoading, message }) => {

  const context = useContext(AppContext);
	const { spinnerVariant, spinnerContainerStyle } = getStyle(context);

	const renderLoadingMessage = () => {
		if (message) {
			return (
				<div style={style.busyIndicatorText}>
					{message}
				</div>
			);
		}
	}

	const renderSpinner = () => {
		if (isLoading) {
			return (
				<div style={style.busyIndicator}>
          <Spinner animation="border" role="status" variant={spinnerVariant}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
				</div>
			);
		}
	}

	if (isLoading) {
		return (
			<div className="d-flex flex-column justify-content-center align-items-center" style={spinnerContainerStyle}>
				{renderSpinner()}
				{renderLoadingMessage()}
			</div>
		);
	}

	return null;
}

export default Component;
